import cn from 'classnames';
/* Constants */
import { HT_INFO_SITELINKS } from '@constants/hellotech';
/* Styles */
import styles from '../footer.module.scss';

const icons = [
  { name: 'facebook', link: HT_INFO_SITELINKS.facebook.url },
  { name: 'twitter', link: HT_INFO_SITELINKS.twitter.url },
  { name: 'linkedin', link: HT_INFO_SITELINKS.linkedin.url },
];

const FooterSocial = () => (
  <div className={cn(styles.socialIconContainer, 'marginLeft-tiny1')}>
    {icons.map(item => (
      <a key={item.name} href={item.link} rel="noreferrer">
        <img alt={item.name} src={`/_nextassets_/icons/${item.name}.svg`} className={styles.socialIcon} />
      </a>
    ))}
  </div>
);

export default FooterSocial;
